import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { isUserAuthenticated } from "../../utils/auth";
import UserHome from "../components/UserHome/UserHome.jsx";
import CropClinic from "../components/CropClinic/CropClinic.js";
import UserLayout from "../layout/UserLayout.js";
import AddFarmPage from "../pages/AddFarmPage.js";
import FarmListPage from "../components/FarmListPage/FarmListPage.js";
import FarmDetailPage from "../components/FarmListPage/FarmDetailPage.js";
import SubscriptionPageList from "../components/SubscriptionsPage/SubscriptionPageList.js";
import ProfilePage from "../components/Profile/ProfilePage.js";
import CropClinicSubscriptionList from "../components/CropClinic/CropClinicSubscriptionList.js";
import HistoryPage from "../components/CropClinic/HistoryPage/HistoryPage.js";
import PDFDocument from "../components/PDFDocument/MyDocument.js";
import MyDocument from "../components/PDFDocument/MyDocument.js";
import AddFarmPage1 from "../pages/AddFarmPage1.js";
import Layout from "../../layout.js";
import RenewFarmPage from "../components/RenewFarm/RenewFarmPage.js";
import FieldFetchPage from "../components/PDFDocument/FieldFetchPage.js";
import TrialAddFarm from "../components/TrialAddFarm/TrialAddFarm.js";
import WeatherCard from "../components/FarmListPage/WeatherCard.js";
import CropMonitor from "../pages/CropMonitor.js";
import PlanDetailPage from "../components/FarmListPage/PlanDetailPage.js";
import FarmReportHistory from "../components/FarmReportHistory/FarmReportHistory.js";

const UserRoutes = () => {
  return (
    <Routes>
      {/* Redirect root to /user/home or login */}
      <Route
        path="/"
        element={
          isUserAuthenticated() ? (
            <Navigate to="/user/home" />
          ) : (
            <Navigate to="/user/login" />
          )
        }
      />

      {/* Routes without layout */}
      <Route
        path="/add-farm-now"
        element={
          <Layout>
            <AddFarmPage1 />
          </Layout>
        }
      />
      <Route path="/trial-add-farm" element={<TrialAddFarm />} />
      <Route path="/weather" element={<WeatherCard />} />

      {/* Routes with UserLayout */}
      <Route element={<UserLayout />}>
        <Route path="/home" element={<UserHome />} />

        <Route path="/crop-clinic" element={<CropClinicSubscriptionList />} />
        <Route path="/crop-clinic/:crop_name" element={<CropClinic />} />
        <Route
          path="/crop-clinic/history/:transactionId"
          element={<HistoryPage />}
        />

        <Route path="/add-farm" element={<AddFarmPage />} />
        <Route path="/crop-health-management" element={<FarmListPage />} />
        <Route
          path="/crop-health-management/farm/:fieldId"
          element={<FarmDetailPage />}
        />
        <Route path="/cropm" element={<CropMonitor />} />
        <Route
          path="/crop-health-management/farm/:fieldId/get-report"
          element={<MyDocument />}
        />
        <Route path="/renew-farm/farm/:fieldId" element={<RenewFarmPage />} />
        <Route path="/my-subscriptions" element={<SubscriptionPageList />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/pdf-viewer" element={<PDFDocument />} />
        <Route
          path="/plantation-farms"
          element={<PlanDetailPage planType="plantation" />}
        />
        <Route
          path="/field-farms"
          element={<PlanDetailPage planType="field" />}
        />
        <Route path="/field/:fieldId/history" element={<FarmReportHistory />} />
        <Route
          path="/reports/farmology_report"
          element={<FarmReportHistory />}
        />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/user/login" />} />
    </Routes>
  );
};

export default UserRoutes;
